import { Reveal } from "./Reveal";

const PILLARS = [
  { number: "01", title: "Elimina el sesgo emocional", desc: "Las agencias inmobiliarias venden ilusión. PisoScore analiza los datos crudos para que no pagues de más." },
  { number: "02", title: "Modelos adaptados al mercado español", desc: "Calculamos ITP por Comunidad Autónoma, gastos notariales, IBI y costes reales de reforma en España." },
  { number: "03", title: "Ahorra semanas de hojas de cálculo", desc: "Sustituye plantillas de Excel complejas por un sistema automatizado que analiza un inmueble en 120 segundos." },
];

export const Manifesto = () => (
  <section id="guias" data-testid="manifesto-section" className="bg-slate-900 py-16 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="mb-14 max-w-3xl sm:mb-20">
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-emerald-400">Manifiesto</p>
        <h2 className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-6xl">
          Decide con números,
          <br />
          no con intuición.
        </h2>
      </Reveal>

      <div className="grid gap-px overflow-hidden rounded-3xl bg-white/10 md:grid-cols-3">
        {PILLARS.map((p, i) => (
          <Reveal key={p.number} delay={i * 0.1} className="bg-slate-900 p-8 sm:p-10">
            <span className="font-mono text-5xl font-bold text-emerald-400/90 sm:text-6xl">{p.number}</span>
            <h3 className="mt-6 font-display text-xl font-bold tracking-tight text-white sm:text-2xl">{p.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-400 sm:text-base">{p.desc}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
